// ======================= Imports =======================
import Axios from "axios";

// ======================= Refresh Access Token Utility =======================
export const RefreshAccessToken = async () => {
  // ======================= Get Refresh Token from Local Storage =======================
  const userData = localStorage.getItem("userData");
  const token = userData ? JSON.parse(userData).refreshToken : null;

  if (!token) {
    return null;
  }

  try {
    // ======================= API Call to Refresh Token =======================
    const response = await Axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/web/user/NewAccesstoken`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // ======================= Handle Response =======================
    if (response.data?.accessToken) {
      const newAccessToken = response.data.accessToken;

      // ======================= Update Local Storage =======================
      const updatedUserData = JSON.parse(userData);
      updatedUserData.token = newAccessToken;
      localStorage.setItem("userData", JSON.stringify(updatedUserData));

      return newAccessToken;
    } else {
      return null;
    }
  } catch (err) {
    // ======================= Error Handling =======================
    console.error("Error refreshing access token:", err);
    return null;
  }
};
